import styled from 'styled-components'

export const Container = styled.div`
background-color: white;
padding: 1rem;
height: 100%;
`

export const HeaderContainer = styled.div`
display: flex;
justify-content: space-between;
padding: 1.5rem 2rem 1rem 2rem;
background-color: white;
align-items: center;

img{
  max-height: 10rem;
  max-width: 10rem;
  object-fit: scale-down;
}
`
